import React from 'react'

import { Icon } from 'elements/media/Icon'
import { TTextProps, Text } from 'elements/text/Text'

import { ICON } from 'config/icons'

export type TChipProps = {
  icon?: ICON
  isLink?: boolean
} & TTextProps

export const Chip: TFCC<TChipProps> = ({
  children,
  icon,
  isLink,
  color = 'black30',
  fontSize = '1em',
  ...otherProps
}) => (
  <Text color={color} fontSize={fontSize} {...otherProps}>
    <Icon name={icon} />
    <Text m="0 0 0 4px" underline={isLink} firstUpper inline vAlign="bottom">
      {children}
    </Text>
  </Text>
)
